export const RASD_ERROR_CODES = [
    // definition / schema
    'RASD_SCHEMA_INVALID',
    /** Newer `rasd` MAJOR, or an unmet `requires` (docs/04 §15, docs/17 §2.3). */
    'RASD_UNSUPPORTED_SPEC',
    // expressions
    'RASD_EXPR_PARSE',
    'RASD_EXPR_UNKNOWN_REF',
    'RASD_EXPR_UNKNOWN_FUNCTION',
    'RASD_EXPR_FUNCTION_EXISTS',
    'RASD_EXPR_CYCLE',
    'RASD_EXPR_RUNTIME',
    'RASD_EXPR_BUDGET',
    // engine
    'RASD_ENGINE_DISPOSED',
    'RASD_ENGINE_INVALID_PATH',
    // migration
    'RASD_MIGRATION_REFUSED',
    // i18n
    'RASD_I18N_SYNTAX',
    // storage (declared here so every package shares one catalogue)
    'RASD_STORAGE_QUOTA',
    'RASD_STORAGE_BUDGET',
    'RASD_STORAGE_NOT_OPEN',
    'RASD_STORAGE_BLOCKED',
    // sync
    'RASD_SYNC_AUTH',
    'RASD_SYNC_REVOKED',
    'RASD_SYNC_NETWORK',
    'RASD_SYNC_REJECTED',
    'RASD_SYNC_CONFLICT',
    'RASD_ATTACHMENT_FAILED',
    // licence
    'RASD_LICENSE_EXPIRED',
    'RASD_LICENSE_INVALID',
    // media
    'RASD_MEDIA_PERMISSION',
    'RASD_MEDIA_UNAVAILABLE',
];
/**
 * The single error type thrown by every Rasd package.
 *
 * `toJSON()` is safe to log: it never includes answer data or tokens, only the
 * code, message, `details` and the retry flag.
 */
export class RasdError extends Error {
    code;
    details;
    cause;
    retryable;
    userMessage;
    constructor(code, message, opts = {}) {
        super(message);
        this.name = 'RasdError';
        this.code = code;
        if (opts.details !== undefined)
            this.details = opts.details;
        if (opts.cause !== undefined)
            this.cause = opts.cause;
        this.retryable = opts.retryable ?? false;
        if (opts.userMessage !== undefined)
            this.userMessage = opts.userMessage;
        // Keep the stack pointing at the throw site, not the constructor.
        // V8-only, and not in `lib.es2022` — core is built with `types: []`, so it is
        // reached through a narrowed `globalThis` rather than an ambient declaration.
        const E = Error;
        E.captureStackTrace?.(this, RasdError);
    }
    toJSON() {
        const out = {
            code: this.code,
            message: this.message,
            retryable: this.retryable,
        };
        if (this.details !== undefined)
            out.details = this.details;
        return out;
    }
}
/** Narrows to `RasdError`, optionally requiring a specific `code` (docs/17 §2.7). */
export function isRasdError(e, code) {
    return e instanceof RasdError && (code === undefined || e.code === code);
}
//# sourceMappingURL=errors.js.map